/**
 * CATMAN-S38 — Etiqueta del error de autoguardado para el modal del editor de planogramas.
 *
 * Devuelve `null` cuando el fallo NO es un error real del servidor: status 0 (corte de red,
 * request cancelada, CORS), errores sin respuesta HTTP o redirects/2xx/3xx inesperados.
 * En esos casos el editor sólo pinta el indicador del header, sin interrumpir con un modal.
 */
export interface AutosaveErrorModalInput {
  error?: any;
  /** false si el editor ya no está abierto: un modal sobre el autoguardado no tendría contexto. */
  sessionActive: boolean;
}

/** Etiqueta a mostrar en el modal, o `null` si este fallo no amerita interrumpir al usuario. */
export function resolveAutosaveErrorModalLabel(input: AutosaveErrorModalInput): string | null {
  if (!input?.sessionActive) return null;
  return getAutosaveErrorStatusLabel(input.error);
}

export function getAutosaveErrorStatusLabel(error?: any): string | null {
  const status = Number(error?.status ?? error?.statusCode);
  if (!Number.isFinite(status) || status < 400) return null;

  const statusText = String(error?.statusText ?? '').trim();
  if (!statusText || statusText.toLowerCase() === 'ok') return `HTTP ${status}`;

  return `HTTP ${status} - ${statusText}`;
}
